import StoreUtil from '@store/StoreUtil';
import { IState } from '@app/store';
import LottoEvent from '@core/models/lotto/LottoEvent';
import { ILottoState } from './types';
import { ExpandedEventInUrl } from '@app/enums';
import { getTimeFilterFromSlug, getDateFromDateSlug } from '@shared/timeFilter/helpers';
import { TimeFilter } from '@shared/timeFilter/enums';

export default {
    /**
     * This getter returns id of event that is active in event grid. Make sure to spot
     * the difference between active event in the grid and event that is in the betSlip.
     *
     */
    expandedEventId: (state: ILottoState, getters: any, rootState: IState, rootGetters: any) => {
        let eventId = rootGetters['navigation/route'].query[ExpandedEventInUrl.event];
        eventId = eventId ? parseInt(eventId, 10) : null;

        if (!rootGetters['data/lottoOffer/lottoEventsMap'][eventId]) {
            return null;
        }
        return eventId;
    },
    favourites: StoreUtil.createSimpleGetter('favourites'),
    areFavouritesSaving: StoreUtil.createSimpleGetter('areFavouritesSaving'),
    selectedFavourites: StoreUtil.createSimpleGetter('selectedFavourites'),
    areFavouritesFetchedUponLogin: StoreUtil.createSimpleGetter('areFavouritesFetchedUponLogin'),
    randomNumbersAmount: StoreUtil.createSimpleGetter('randomNumbersAmount'),
    nextRound(state: ILottoState, getters: any, rootState: IState, rootGetters: any) {
        return (event: {
            lottoId: LottoEvent['lottoId'],
        }) => {
            const visibleEvents = rootGetters['ui/lotto/filter/lottoEvents'];
            return visibleEvents.find((item: LottoEvent) =>
                        item.lottoId === event.lottoId && item.endBet!.getTime() > (new Date()).getTime());
        };
    },
    selectedSidebarComponent: StoreUtil.createSimpleGetter('selectedSidebarComponent'),
    timeFilter(state: ILottoState, getters: any, rootState: IState, rootGetters: any) {
        const { timeFilter, date } = rootState.route.params;
        if (!timeFilter && date) {
            return getDateFromDateSlug(date);
        }
        return timeFilter ? getTimeFilterFromSlug(timeFilter) : TimeFilter.today;
    },
    isLoading: StoreUtil.createSimpleGetter('isLoading'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/getters.ts